module.exports = __webpack_public_path__ + "img/step_7.3b173462.png";